import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginWithFirebase } from "state/authActions";
import { useNavigate } from "react-router-dom";
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); // 🌀 Spinner state

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userRole = useSelector((state) => state.global.userRole);
  const token = useSelector((state) => state.global.token);

  useEffect(() => {
    if (token && userRole === "admin") {
      navigate("/admin", { replace: true });
    }
  }, [token, userRole, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const result = await dispatch(loginWithFirebase(email, password));
    setLoading(false);

    if (result?.error) {
      setError(result.error);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <h2 className="login-title">Connexion à l'espace admin</h2>

        {error && <p className="login-error">{error}</p>}

        <form onSubmit={handleLogin} className="login-form">
          <input
            type="email"
            placeholder="Votre Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="login-input"
            autoComplete="email"
          />
          <input
            type="password"
            placeholder="Mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="login-input"
            autoComplete="current-password"
          />
          <button
            type="submit"
            className="login-button"
            disabled={loading}
          >
            {loading ? (
              <div className="spinner" />
            ) : (
              "Se connecter"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
